var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommonDiscount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-1588.000000, -638.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Common/Discount",
    transform: "translate(1588.000000, 638.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,0 C24.8,0 32,7.2 32,16 C32,24.8 24.8,32 16,32 C7.2,32 0,24.8 0,16 C0,7.2 7.2,0 16,0 Z M22,15.3 C19.7,15.3 18.5,17 18.5,20.2 L18.5,20.2 L18.5,20.6 C18.5,23.9 19.7,25.5 22,25.5 C24.3,25.5 25.5,23.9 25.5,20.6 L25.5,20.6 L25.5,20.2 C25.5,16.9 24.3,15.3 22,15.3 Z M22.4,6.7 C21.5,6.1 20.2,6.4 19.7,7.4 L19.7,7.4 L9.8,25 C10.7,25.6 12,25.3 12.5,24.3 L12.5,24.3 Z M22,16.9 C22.4,16.9 22.7,17 22.9,17.2 C23.1,17.4 23.3,17.6 23.4,18 C23.5,18.4 23.6,18.7 23.6,19.1 C23.7,19.5 23.7,19.9 23.7,20.4 L23.7,20.4 L23.7,20.6 C23.7,21.1 23.6,21.5 23.6,21.9 C23.6,22.3 23.5,22.6 23.4,23 C23.3,23.3 23.1,23.6 22.9,23.8 C22.7,24 22.4,24.1 22,24.1 C21.6,24.1 21.3,24 21.1,23.8 C20.9,23.6 20.7,23.4 20.6,23 C20.5,22.6 20.4,22.3 20.4,21.9 C20.3,21.5 20.3,21.1 20.3,20.6 L20.3,20.4 C20.3,19.9 20.4,19.5 20.4,19.1 C20.4,18.7 20.5,18.4 20.6,18 C20.7,17.7 20.9,17.4 21.1,17.2 C21.3,17 21.6,16.9 22,16.9 Z M10,6.7 C7.7,6.7 6.5,8.4 6.5,11.6 L6.5,11.6 L6.5,12 C6.5,15.3 7.7,16.9 10,16.9 C12.3,16.9 13.5,15.3 13.5,12 L13.5,12 L13.5,11.6 C13.5,8.3 12.3,6.7 10,6.7 Z M10,8.2 C10.4,8.2 10.7,8.3 10.9,8.5 C11.1,8.7 11.3,8.9 11.4,9.3 C11.5,9.7 11.6,10 11.6,10.4 C11.7,10.8 11.7,11.2 11.7,11.7 L11.7,11.7 L11.7,11.9 C11.7,12.4 11.6,12.8 11.6,13.2 C11.6,13.6 11.5,13.9 11.4,14.3 C11.3,14.6 11.1,14.9 10.9,15.1 C10.7,15.2 10.4,15.3 10,15.5 C9.6,15.5 9.3,15.4 9.1,15.2 C8.9,15 8.7,14.8 8.6,14.4 C8.5,14 8.4,13.7 8.4,13.3 C8.3,12.9 8.3,12.5 8.3,12 L8.3,11.8 C8.3,11.3 8.4,10.9 8.4,10.5 C8.4,10.1 8.5,9.8 8.6,9.4 C8.7,9 8.9,8.8 9.1,8.5 C9.3,8.3 9.6,8.2 10,8.2 Z",
    id: 302
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonDiscount);
export default __webpack_public_path__ + "static/media/common-discount.5e41e238.svg";
export { ForwardRef as ReactComponent };